module.exports = __webpack_public_path__ + "static/media/go-to-workspace.5e0ba319.svg";